export default __webpack_public_path__ + "static/media/DarkBell.b7287441.svg";